export const breadcrumb = {
  title: 'Autoinformer',

  campaign: {
    index: 'Campaigns',
    edit: 'Edit Campaign',
    new: 'Add Campaign',
    tasks: 'Tasks {name}'
  },

  tasks: { create: 'Create task' }
};
